import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="footer-brand">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="7.5" r="3.4" fill="#FFD166" />
                <path d="M2.5 15c1.8-2.2 4-2.2 5.8 0s4 2.2 5.8 0 4-2.2 5.8 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none" />
                <path d="M2.5 19.2c1.8-2.2 4-2.2 5.8 0s4 2.2 5.8 0 4-2.2 5.8 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.65" />
              </svg>
              ShareTime
            </div>
            <p className="footer-tagline">
              A peer-to-peer marketplace for timeshare stays — fair prices for owners and travelers, no hidden fees.
            </p>
          </div>

          <div className="footer-col">
            <div className="footer-col-title">Explore</div>
            <Link to="/search">Find a Stay</Link>
            <Link to="/browse">Browse Listings</Link>
            <Link to="/browse">Timeshares For Sale</Link>
          </div>

          <div className="footer-col">
            <div className="footer-col-title">Owners</div>
            <Link to="/register?role=owner">List Your Stay</Link>
            <Link to="/login">Owner Login</Link>
          </div>

          <div className="footer-col">
            <div className="footer-col-title">Account</div>
            <Link to="/register">Sign Up</Link>
            <Link to="/login">Log In</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <span>
            &copy; {new Date().getFullYear()} Blue Signal LLC · <Link to="/privacy">Privacy Policy</Link> · <Link to="/terms">Terms of Use</Link>
          </span>
          <span>Made for owners and travelers in Florida</span>
        </div>
      </div>
    </footer>
  );
}
